// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, SliderItem } from "../flow/types";

export default function (state = initialState.sliderItems, action) {
  switch (action.type) {
      case ActionTypes.GET_ACTIVE_SLIDER_ITEMS + ActionTypes.FULFILLED:
      var data = action.payload.data;
          const result: EntityList<SliderItem> = new EntityList(data, 1);
      return result;
    default:
      return state;
  }
}
